import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PortalWebService {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) {
  }

  sendComprobanteVenta(id_cia: number, numint: number) {
    return this.httpClient.post(environment.serviceUrl_FE + "send-portal-tsi/comprobante-venta/" + id_cia + "/" + numint, { observe: 'response' },)
  }

  sendComprobantePercepcion(id_cia: number, numint: number) {
    return this.httpClient.post(environment.serviceUrl_FE + "send-portal-tsi/percepcion/" + id_cia + "/" + numint, { observe: 'response' },)
  }

  sendComprobanteRetencion(id_cia: number, numint: number) {
    return this.httpClient.post(environment.serviceUrl_FE + "send-portal-tsi/retencion/" + id_cia + "/" + numint, { observe: 'response' },)
  }

  sendComprobanteGuiaRemision(id_cia: number, numint: number) {
    return this.httpClient.post(environment.serviceUrl_FE + "send-portal-tsi/guia-remision/" + id_cia + "/" + numint, { observe: 'response' },)
  }

  sendCorreo(id_cia: number, numint: number) {
    return this.httpClient.post(environment.serviceUrl_FE + "send-portal-tsi/reenviar-correo/" + id_cia + "/" + numint, { observe: 'response' },)
  }

  sendCorreoMasivo(numints: any, id_cia: number) {
    return this.httpClient.post(environment.serviceUrl_FE +"send-portal-tsi/reenviar-correo-masivo/" + id_cia,numints, { observe: 'response' });
    //return this.apiService.executePostJson(numints).pipe();
  }

  getPendientesEnvio(id_cia: number) {
    return this.httpClient.get(environment.serviceUrl_FE + "send-portal-tsi/pendientes-envio/" + id_cia, { observe: 'response' },)
  }


}
